import React, { useState } from 'react'
import styles from './student-apply-modal.scss'
import ReactModal from 'react-modal'

const StudentApplyModal = ({ onClose, title }) => {
  const [ applyList, setApplyList ] = useState([1, 2, 3, 4, 5, 6])
  const handleAllowed = () => {
    console.log(1111);
  }
  const handleRefused = () => {
    console.log(2222);
  }
  return (
    <ReactModal
      overlayClassName={styles.ReactModal__Overlay}
      className={styles.ReactModal__Content}
      isOpen={true}
      title={window.L('teach.user.helper')}
      closeTimeoutMS={400}
    >
      <div className={styles.applyContainer}>
        <div className={styles.header}>
          <div className={styles.titleBlock}></div>
          <div className={styles.titleBlock}>
            <span>{title}</span>
          </div>
          <div className={styles.titleBlock} onClick={onClose}>
            <p>×</p>
            <p>关闭</p>
          </div>
        </div>
        <div className={styles.applyArea}>
          <ul>
            {
              applyList.map((item, index) => (
                <li key={index}>
                  <div className={styles.info}>
                    <p>学生姓名</p>
                    <p>申请信息xxxxxxxxxxxxxx</p>
                  </div>
                  <div className={styles.optionBtn}>
                    <span onClick={handleAllowed}>通过</span>
                    <span onClick={handleRefused}>拒绝</span>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </ReactModal>
  )
}

export default StudentApplyModal
